import { Box } from '@material-ui/core';
import { Captions, SmallSectionHeader } from 'components/Typography';
import React from 'react';
import styled from 'styled-components';

export const StyledCaptions = styled(Captions)`
  &&& {
    letter-spacing: 0;
    line-height: 16px;
    font-size: 13px !important;
    margin-bottom: 0px;
  }
`;

export const ItemWrapper = styled(({ reverse, ...othersProps }) => (
  <Box {...othersProps} />
))`
  display: flex;
  align-items: center;
  width: 100%;
  img {
    margin-left: ${(props) => (props.reverse ? '6px' : '0px')};
    margin-right: ${(props) => (props.reverse ? '0px' : '6px')};
  }
`;
export const StyledImg = styled.img`
  width: 18px !important;
  height: 18px !important;
`;
export const SizedSmallSectionHeader = styled(SmallSectionHeader)`
  && {
    margin-bottom: 24px;
    letter-spacing: 0;
    line-height: 23px;
  }
`;
export const StyledList = styled.ul`
  margin: 0px;
  list-style-type: none;
  padding-left: 25px;
`;
export const AccordionDetailsCaptions = styled(Captions)`
  &&& {
    letter-spacing: 0;
    line-height: 16px;
    margin-bottom: 5px;
  }
`;
